import * as constants from './constants'

export const getReservationConfirmation = (reservationId, confirmationNumber, orderEmailAddress) => ({
    type: constants.GET_RESERVATION_CONFIRMATION,
    reservationId,
    confirmationNumber,
    orderEmailAddress,
})

export const getReservationConfirmationResponse = (parkingPassUrl, parkingPassRequirements) => ({
    type: constants.GET_RESERVATION_CONFIRMATION_RESPONSE,
    parkingPassUrl,
    parkingPassRequirements,
})
